export function getStepValue(value: number): number {
  return Math.round(Math.trunc(value) * 0.05);
}
